import React, {Fragment} from 'react';
import TopNav from "../../layouts/navs/auth-toplandlords";
import BannerLandlordRentalApp from "../../layouts/banners/landlordrentalapp";
import MOGULHome from "../about/components/main/home";
import SplashBanner from "../../layouts/banners/splash1";
import SplashBanner2 from "../../layouts/banners/splash2";
import SplashBanner3 from "../../layouts/banners/splash3";
import LandlordMain from "./components/main/index1";
import LandlordMain2 from "./components/main/index2";
import LandlordMain3 from "./components/main/index3";
import LandlordMain4 from "./components/main/index4";
import LandlordMain5 from "./components/main/index5";
import TenantVerify2 from "../tenants/components/main/verify2";

const AboutPage = () => {
    return (
        <Fragment>
            <TopNav/>
            {/* <BannerLandlordRentalApp/> */}
            <MOGULHome/>
            <LandlordMain3/>
            <SplashBanner3/>
            <LandlordMain4/>
            <LandlordMain/>
            <SplashBanner2/><br/><br/><br/>
            <TenantVerify2/>
            {/* <LandlordMain2/> */}
            <LandlordMain5/>
        </Fragment>
    );
};

export default AboutPage;
